

export default (name) => (resolve) => 
require ([`@/views/${name}.vue`], resolve)
/* import('../../pages/stock/whOutputDetail') // 返回promise
reqiure('../../pages/stock/whOutputDetail') // 返回组件对象 */